import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = {
  class: "messages-container overflow-y-auto h-80 mb-4",
  ref: "scrollable"
}
const _hoisted_3 = { class: "flex items-center justify-center px-12 mb-3" }
const _hoisted_4 = { class: "border rounded-lg p-3 text-sm max-w-md" }
const _hoisted_5 = { class: "font-medium mb-1 text-sky" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Learn about commercial real estate and business financing, get answers to all of your questions, and find out what the best options on the market are for your business.", -1)
const _hoisted_7 = { class: "block p-3 mb-2 rounded-lg border" }
const _hoisted_8 = { class: "flex justify-between mb-2 text-sm" }
const _hoisted_9 = { class: "block pl-3 opacity-50" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-sky"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, "Welcome to " + _toDisplayString(_ctx.originator.Name) + " AI Chat!", 1),
          _hoisted_6
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["message flex", {
          'pr-24 justify-start': message.sender === 'system',
          'pl-24 justify-end': message.sender === 'user'
        }])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(["font-medium", { 'text-sky': message.sender == 'user' }])
              }, _toDisplayString(message.sender == 'system' ? 'AI Assistant' : 'You'), 3),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatTime(message.timestamp)), 1)
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(message.text), 1)
          ])
        ], 2))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, "AI Assistant is typing..."))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("form", {
      class: "input-container flex",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMessage) = $event)),
        type: "text",
        placeholder: "Type a message",
        class: "flex-grow p-2 px-3 rounded-lg border border-gray-300"
      }, null, 512), [
        [_vModelText, _ctx.newMessage]
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass(["ml-2 p-2 px-8 rounded-lg bg-sky text-white", { 'opacity-50 pointer-events-none': _ctx.loading }])
      }, " Send ", 2)
    ], 32)
  ]))
}